// ----------------------------------------------------------------------

const ROOTS = {
  DASHBOARD: "/dashboard",
};

// ----------------------------------------------------------------------

const withLocale = (path: string, lang: AppLocale) => `/${lang}${path}`;

// ----------------------------------------------------------------------

export const paths = (lang: AppLocale) =>
  ({
    home: withLocale("/", lang),
    login: withLocale(`/login`, lang),
    logout: withLocale(`/logout`, lang),
    // DASHBOARD
    dashboard: {
      root: withLocale(ROOTS.DASHBOARD, lang),
      analytics: withLocale(`${ROOTS.DASHBOARD}/analytics`, lang),
      messages: withLocale(`${ROOTS.DASHBOARD}/messages`, lang),
      applications: withLocale(`${ROOTS.DASHBOARD}/applications`, lang),
      waitingList: withLocale(`${ROOTS.DASHBOARD}/waiting-list`, lang),
      bookings: withLocale(`${ROOTS.DASHBOARD}/bookings`, lang),
      videoLibrary: withLocale(`${ROOTS.DASHBOARD}/video-library`, lang),
      pages: withLocale(`${ROOTS.DASHBOARD}/pages`, lang),
    },
    // Pages
    aboutUs: withLocale("/om-oss", lang),
    privacyPolicy: withLocale("/privacy-policy", lang),
    lessonsKids: withLocale("/fiol-stockholm-bromma-barn", lang),
    availableSlots: withLocale("/tillgangliga-tider", lang),
    practiceTips: withLocale("/ovningstips", lang),
    practiceVids: withLocale("/ovningsvideor", lang),
    signUp: withLocale("/anmalan", lang),
    waitingList: withLocale("/kolista", lang),
    contact: withLocale("/kontakt", lang),
    instagram: "https://www.instagram.com/simonetrollmo_violinpedagog/",
    facebook: "https://www.facebook.com/simoneviolinist/",
    youtube: "https://www.youtube.com/channel/UCrx7w0cAmgCfuYGEpgYq-5g",
    dollsInstagram: "https://www.instagram.com/natimati_wonderworld/",
  }) as const;
